var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container",staticStyle:{"overflow":"hidden"}},[(_vm.$route.name == 'Exam')?_c('HeaderExam'):_c('Header'),_c('router-view',{key:_vm.$route.fullPath})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }